import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import QueryState from '../query_state'
import Details from './details'
import Items from './items'

const List = ({ schema, disabled }) => {
  const params = useParams()
  const { data: collection, isLoading, isError, error } = useQuery(['collections/', params.listID])

  return (
    <QueryState isLoading={isLoading} error={isError ? error : null}>
      {collection ? (
        <Routes>
          <Route path='details' element={<Details collection={collection} schemaLocked={schema.is_locked} />} />
          <Route
            path='items'
            element={
              <Items
                collection={collection}
                schema={schema}
                disabled={disabled}
                cycleID={params.cycleID}
                airlineID={params.airlineID}
              />
            }
          />
          <Route path='*' element={<Navigate to='details' replace />} />
        </Routes>
      ) : null}
    </QueryState>
  )
}

export default List
